"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductNameAndCategories_1 = require("../model/ProductNameAndCategories");

var ProductNameAndCategoriesConverter_1 = require("./ProductNameAndCategoriesConverter");
/**
 * @author Radek Beran
 */


var ProductNameAndCategoriesConverterImpl =
/*#__PURE__*/
function (_ProductNameAndCatego) {
  _inherits(ProductNameAndCategoriesConverterImpl, _ProductNameAndCatego);

  function ProductNameAndCategoriesConverterImpl() {
    _classCallCheck(this, ProductNameAndCategoriesConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductNameAndCategoriesConverterImpl).apply(this, arguments));
  }

  _createClass(ProductNameAndCategoriesConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductNameAndCategories_1.ProductNameAndCategories(ProductNameAndCategories_1.ProductNameAndCategories.schema.id.valueOf(conversions.documentToClassId(source)), ProductNameAndCategories_1.ProductNameAndCategories.schema.externalId.valueOfField(source), ProductNameAndCategories_1.ProductNameAndCategories.schema.name.valueOfField(source), ProductNameAndCategories_1.ProductNameAndCategories.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      return result;
    }
  }]);

  return ProductNameAndCategoriesConverterImpl;
}(ProductNameAndCategoriesConverter_1.ProductNameAndCategoriesConverter);

exports.ProductNameAndCategoriesConverterImpl = ProductNameAndCategoriesConverterImpl;